export type RegisterClickParams = {
  source: string;
  label?: string;
};

export function trackRegisterClick({ source, label }: RegisterClickParams) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', 'register_click', {
    click_source: source,
    button_label: label,
    page_path: window.location.pathname,
  });
}
